'use strict';

var React = require('react'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    FormMixin = require('../mixins/FormMixin'),
    StampStore = require('../stores/StampStore'),
    UserStore = require('../stores/UserStore'),
    ZineStore = require('../stores/ZineStore'),
    SidebarBody = require('../organisms/SidebarBody'),
    FormInput = require('../atoms/FormInput'),
    Button = require('../atoms/Button'),
    Textarea = require('../atoms/Textarea'),
    ZineActionCreators = require('../actions/ZineActionCreators'),
    PendingStampMessageMixin = require('../mixins/PendingStampMessageMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    getStampSegment = require('../utils/getStampSegment'),
    { PropTypes } = React;

var RejectPendingStamp = React.createClass({
  mixins: [
    FormMixin,
    PendingStampMessageMixin,
    createStoreMixin(StampStore, ZineStore),
    PureRenderMixin
  ],

  propTypes: {
    stampId: PropTypes.number.isRequired,
    zineSlug: PropTypes.string.isRequired
  },

  getStateFromStores(props) {
    var stamp = StampStore.get(props.stampId),
        zine = ZineStore.get(props.zineSlug),
        author = UserStore.get(stamp.user);

    return {
      stamp: stamp,
      zine: zine,
      author: author
    };
  },

  render() {
    var { zine, author } = this.state;

    return (
      <SidebarBody title={'Decline Submission to “' + zine.title + '”'}
                   subtitle='You can add an optional message for the author.'>
        {/* TODO: add and use FormGroup */}
        <div className='utils--fullWidth'>
          <FormInput component={Textarea}
                     size='small'
                     placeholder={'Message for ' + author.name}
                     formLink={this.linkState('message')}
                     readOnly={!this.isFormEditable()}
                     hasMinHeight />

          <Button size='large'
                  color='red'
                  fill
                  onClick={this.handleConfirmClick}
                  disabled={!this.isFormEditable()}
                  fullWidth>
            Decline
          </Button>
        </div>
      </SidebarBody>
    );
  },

  handleConfirmClick() {
    this.removeStoredPendingMessage();

    var { zineSlug } = this.props,
        { message, stamp } = this.state;

    const stampFragment = getStampSegment(stamp);
    ZineActionCreators.rejectStampFromZine(zineSlug, stampFragment, message);
  }
});

module.exports = RejectPendingStamp;



/** WEBPACK FOOTER **
 ** ./sidebar/RejectPendingStamp.jsx
 **/